// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as RestrictionBound from "../entity/RestrictionBound.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as RestrictionBoundApiModel from "../api-model/RestrictionBoundApiModel.bs.js";

function getPickupDropPolygon(restrictionPolygon) {
  return $$Array.map((function (e) {
                return $$Array.map((function (v) {
                              return {
                                      lat: Caml_array.get(v, 1),
                                      lng: Caml_array.get(v, 0)
                                    };
                            }), e);
              }), restrictionPolygon);
}

function apiModelToEntity(data) {
  return $$Array.map((function (e) {
                return {
                        id: e.id,
                        polygon: RestrictionBound.stringToVariant(e.restriction_type, getPickupDropPolygon(e.polygon)),
                        vehicle_ids: e.vehicle_ids
                      };
              }), data.restrictions);
}

function execute(json) {
  return apiModelToEntity(DeccoUtils$Catalyst.resolveResult(RestrictionBoundApiModel.t_decode(json), "RestrictionBoundEntityMapper.res"));
}

export {
  getPickupDropPolygon ,
  apiModelToEntity ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
